var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16TrendArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 4.8,
    viewBox: "0 0 6 4.8",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L6,4.8 H0 Z",
    transform: "translate(6 4.8) rotate(180)",
    fill: "#f33e3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16TrendArrowDown);
export default __webpack_public_path__ + "static/media/kbv-v16-trend-arrow-down.bd972cedd0ab5e840bb8c587ece4b9e1.svg";
export { ForwardRef as ReactComponent };